// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__mf0is","detailsBorder":"styles_detailsBorder__1pWfc"};